import { session_wechat, session_qqconnect } from "@tencent/midas-util"

export class MsdkAccount {
  init() {
    return new Promise((resolve, reject) => {
      const _msdkLoginParams = window._msdkLoginParams || ""
      if (_msdkLoginParams) {
        if (_msdkLoginParams.acctype === "wx" || _msdkLoginParams.acctype === "weixin") {
          let loginState = new session_wechat({
            openid: _msdkLoginParams.openid,
            accessToken: _msdkLoginParams.access_token,
            appid: _msdkLoginParams.appid
          })
          resolve({ loginState: loginState })
        } else if (_msdkLoginParams.acctype === "qq") {
          let loginState = new session_qqconnect({
            openid: _msdkLoginParams.openid,
            accessToken: _msdkLoginParams.access_token,
            qq_appid: _msdkLoginParams.appid
          })
          resolve({ loginState: loginState })
        } else {
          reject("无登录态")
        }
      } else {
        reject("msdk is undefined")
      }
    })
  }
}
